import { render, staticRenderFns } from "./TemplateSessions.vue?vue&type=template&id=7b2d0e74"
import script from "./TemplateSessions.vue?vue&type=script&lang=js"
export * from "./TemplateSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports